import { useState } from 'react';
import { supabase, isSupabaseConfigured } from '../lib/supabase';

// Hook for newsletter subscription
export const useNewsletterSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  /**
   * @param honeypot  Inhalt des versteckten Felds — bei Menschen immer leer.
   * @param formLoadedAt  Zeitpunkt des Formular-Renderings. Die Edge Function
   *                      wertet aus, wie schnell abgeschickt wurde.
   */
  const subscribe = async (email: string, honeypot = '', formLoadedAt?: number) => {
    if (!isSupabaseConfigured()) {
      setError('Newsletter-Service ist nicht verfügbar');
      return false;
    }

    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      // Call our edge function to send verification email
      const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-newsletter-verification`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.toLowerCase().trim(),
          website: honeypot,
          formLoadedAt
        })
      }
      )
      const result = await response.json();
      
      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Fehler beim Senden der Bestätigungs-E-Mail');
      }

      // Set success message based on whether already subscribed
      if (result.alreadySubscribed) {
        setSuccess('Diese E-Mail-Adresse ist bereits für unseren Newsletter angemeldet.');
      } else {
        setSuccess('Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet. Bitte prüfen Sie Ihr Postfach und klicken Sie auf den Bestätigungslink.');
      }
      setSuccess(true);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler bei der Newsletter-Anmeldung');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { subscribe, loading, error, success };
};